
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.679 2.022H.32A.33.33 0 010 1.685V.337A.33.33 0 01.321 0H23.68A.33.33 0 0124 .337v1.348a.33.33 0 01-.321.337zm-5.92 8.967H.24c-.133 0-.241-.15-.241-.334V9.322c0-.184.108-.333.241-.333H17.76c.133 0 .241.149.241.333v1.333c0 .185-.108.334-.241.334zM23.679 20H.32A.33.33 0 010 19.663v-1.348a.33.33 0 01.321-.337H23.68a.33.33 0 01.321.337v1.348a.33.33 0 01-.321.337z","fill":"#333","fill-rule":"nonzero"}})])
          )
        }
      }
    